export default {
  GITHUB_URL: 'https://github.com/imerss/checklist-generator',
  APP_STATE_VERSION: 3,
};
